module.exports = __webpack_public_path__ + "img/disguise_logo_RGB_White.b3dec727.svg";